module.exports = {
	"id": "CH",
	"name": "Switzerland",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.011892,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.035676,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.005946,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.023784,
			"32": 0.011892,
			"33": 0.023784,
			"34": 0.023784,
			"35": 0.017838,
			"36": 0.017838,
			"37": 0.017838,
			"38": 0.041622,
			"39": 0.035676,
			"40": 0.017838,
			"41": 0.041622,
			"42": 0.035676,
			"43": 0.083244,
			"44": 0.041622,
			"45": 0.071352,
			"46": 0.053514,
			"47": 0.11892,
			"48": 0.095136,
			"49": 0.957306,
			"50": 0.124866,
			"51": 0.392436,
			"52": 0.392436,
			"53": 13.432014,
			"54": 3.383274,
			"55": 0.035676,
			"56": 0.011892,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.011892,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.02973,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.005946,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.005946,
			"25": null,
			"26": 0.011892,
			"27": 0.005946,
			"28": 0.011892,
			"29": 0.011892,
			"30": 0.011892,
			"31": 0.053514,
			"32": 0.005946,
			"33": 0.023784,
			"34": 0.017838,
			"35": 0.041622,
			"36": 0.02973,
			"37": 0.02973,
			"38": 0.142704,
			"39": 0.047568,
			"40": 0.041622,
			"41": 0.077298,
			"42": 0.083244,
			"43": 0.112974,
			"44": 0.095136,
			"45": 0.41622,
			"46": 0.214056,
			"47": 0.582708,
			"48": 0.975144,
			"49": 9.109272,
			"50": 0.065406,
			"51": 0.011892,
			"52": null,
			"3.5": null,
			"3.6": 0.017838
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.023784,
			"31": 0.023784,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.017838,
			"37": 0.017838,
			"38": 0.035676,
			"39": 0.011892,
			"40": 0.344868,
			"41": 0.053514,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.005946,
			"12.1": 0.065406
		},
		"safari": {
			"0": null,
			"4": 0.023784,
			"5": 0.112974,
			"6": 0.035676,
			"7": 0.065406,
			"8": 0.404328,
			"9": 0.68379,
			"10": 4.203822,
			"3.1": null,
			"3.2": null,
			"5.1": 0.344868,
			"6.1": 0.255678,
			"7.1": 0.02973,
			"9.1": 2.984892
		},
		"ios_saf": {
			"8": 0,
			"10": 14.9096060949,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.401796631973,
			"8.1-8.4": 0.74230225229,
			"9.0-9.2": 0.354125845129,
			"9.3": 5.40268917569
		},
		"android": {
			"3": 0,
			"4": 0.0134923824289,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00168654780362,
			"4.1": 0.0486689509044,
			"4.2-4.3": 0.121672377261,
			"4.4": 0.279003193798,
			"4.4.3-4.4.4": 0.281412547804
		},
		"ie": {
			"6": null,
			"7": 0.0178730107949,
			"8": 0.184687778214,
			"9": 0.280010502453,
			"10": 0.303841183513,
			"11": 11.355319525,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00810766234956,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000225212843043
		},
		"edge": {
			"12": 0.095136,
			"13": 0.850278,
			"14": 2.818404
		},
		"ie_mob": {
			"10": 0.0823361690141,
			"11": 0.335225830986
		},
		"bb": {
			"7": 0.016216,
			"10": null
		},
		"samsung": {
			"0": 5.181012
		},
		"and_uc": {
			"0": 0.149998
		},
		"op_mini": {
			"0": 0.109233124807
		},
		"and_chr": {
			"0": 10.64609
		},
		"and_ff": {
			"0": 0.064864
		}
	},
	"total": 96.659476
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/CH.json
 ** module id = 493
 ** module chunks = 0
 **/